export const UNAUTHENTICATED_SESSION_TOKEN_KEY = 'unauthenticated_session_token';
